import { render } from "./SmsVerificationSuccess.vue?vue&type=template&id=6da15900"
import script from "./SmsVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./SmsVerificationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__